import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import PropTypes from 'prop-types';
/**
 * A component to display summarized table data - the list of data passed in on a single line.
 *
 * @return { object } -
 */

var TableSummary = function TableSummary(_ref) {
  var data = _ref.data;
  return createElement("ul", {
    className: "woocommerce-table__summary"
  }, data.map(function (_ref2, i) {
    var label = _ref2.label,
        value = _ref2.value;
    return createElement("li", {
      className: "woocommerce-table__summary-item",
      key: i
    }, createElement("span", {
      className: "woocommerce-table__summary-value"
    }, value), createElement("span", {
      className: "woocommerce-table__summary-label"
    }, label));
  }));
};

TableSummary.propTypes = {
  /**
   * An array of objects with `label` & `value` properties, which display on a single line.
   */
  data: PropTypes.array
};
export default TableSummary;
//# sourceMappingURL=summary.js.map